import { platforms } from "@/mocks/nanaData";

export default function PlatformStrip() {
  return (
    <section className="relative z-10 -mt-10 px-4 md:px-6" aria-label="平台入口">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {platforms.map((p) => (
          <div
            key={p.name}
            className="group flex cursor-pointer items-start gap-3 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200"
          >
            <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${p.color}`}>
              <i className={`${p.icon} text-xl`}></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="whitespace-nowrap text-sm font-semibold text-foreground-900">{p.name}</h3>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-700">{p.count}</span>
              </div>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{p.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}